export default [
    {
        path: '/admin',
        exact: true,
        component: 'AdminMenu',
        mui: true,
    }
]